import { GoogleTagManager, GTMHighlight } from '@components';
import { getUrlParamNumberValue } from '@utils/urlParam';
import { increaseButtonLinkParameter } from '@utils/loadMore';

import { ClassLoadMore } from './ClassLoadMore';
import {
  EVENT_BEFORE_LOAD,
  EVENT_AFTER_LOAD,
  EVENT_AFTER_INSERT,
  EVENT_ERROR,
  LoadMoreConfig,
} from './ConfigLoadMore';

import { halfPageManagerRecalculate } from '@box/ads/HalfPageManager/halfPageManagerRecalculate';

export const LoadMore = (elements: NodeListOf<HTMLLinkElement> | null): void => {
  if (!elements) return;

  const GTM = new GoogleTagManager();

  // Scan všech elementů s [data-load-more]
  [...elements].forEach((element: HTMLLinkElement | null): void => {
    if (!element) return;

    const { boxId, nextRequestUrl, urlParameter, loadingText, magazineName }: LoadMoreConfig =
      element.dataset;

    if (!boxId) return;

    const target: HTMLDivElement | null = document.querySelector(
      `[data-load-more-target="${boxId}"]`
    );

    const errorMessageEl: HTMLParagraphElement | null = document.querySelector(
      `[data-load-more-error="${boxId}"]`
    );

    const page = getUrlParamNumberValue(nextRequestUrl as string, urlParameter as string, 2);

    new ClassLoadMore(element, target as HTMLDivElement, {
      boxId,
      page,
      loadingText,
      magazineName,
    });

    element.addEventListener(EVENT_BEFORE_LOAD, (event) => {
      if (!errorMessageEl) return;

      errorMessageEl.hidden = true;
      element.setAttribute('data-recombee-disabled', '');

      GTM.track();
      GTM.send((event as CustomEvent).detail.pageNumber, 'magazine');
    });

    element.addEventListener(EVENT_AFTER_LOAD, () => {
      element.removeAttribute('data-recombee-disabled');
    });

    element.addEventListener(EVENT_AFTER_INSERT, () => {
      if (window.cncImageLazyload && window.prepareLazyLoad) {
        window.prepareLazyLoad.detail();
        window.cncImageLazyload.update();
      }

      // Zvýraznit GTM elementy
      GTMHighlight();

      GTM.track();

      // Přepočítat pozice bannerů
      halfPageManagerRecalculate();

      // Navýšit +1 parametr 'page' v odkazu tlačítka
      if (element) increaseButtonLinkParameter(element);
    });

    element.addEventListener(EVENT_ERROR, () => {
      if (!errorMessageEl) return;

      errorMessageEl.hidden = false;
    });
  });
};

export default LoadMore;
